<template>
  <span v-if="value.limitTime > 0" >
    <span>{{showContent}}</span>
  </span>
</template>

<script>
import utils from '@/js/page/pageUtil.js'
export default {
  name: 'CountDown',
  props: {
    //验证码倒计时的时长(秒)
    value: Object,
    // 是否暂停 根据是否显示试题状态进行判断
    buttonType:Object
  },
  data() {
    return {
      //setTimeout 对象
      authTimeTimer:null
    };
  },
  created() {
    console.log(this.value,'=========================CountDown')
    //this.setTime(60);
    this.start();
  },
  mounted() {
    
  },
  watch:{
  },
  computed:{
    showContent:function(){
      return utils.formatSeconds(this.value.nowTime);
    },
    // 定时器是否执行状态 为true进行倒计时 为false暂停 不减时间
    downState:function(){
      var downState = true;
      if(this.buttonType && !this.buttonType.openQuestionFlag) {
        downState = false;
      }
      if(this.buttonType && this.buttonType.openPrevFlag) {
        downState = true;
      }
      return downState;
    }
  },
  components: {
  },
  beforeDestroy(){
    if (this.authTimeTimer) {
      clearInterval(this.authTimeTimer);
    }
  },
  methods: {
    /**
     *强制刷新组件
     **/
    reload() {
      console.log('强制刷新倒计时组件')
      this.$forceUpdate()
    },
    /**
      设置倒计时 时长(秒) 并开始倒计时
     */
    setTime(miao){
      this.value.limitTime = miao;
      console.log("value==init=========",this.value);
      this.start();
    },
    /**
      * 定时器开始执行
      */
    start() {
      var that = this;
      if (this.authTimeTimer) {
          clearInterval(this.authTimeTimer);
      }
      console.log("value==init==========",this.value.limitTime,(isNaN(that.value.limitTime)));
      if(isNaN(that.value.limitTime)) {
        that.value.limitTime = 0;
      }
      if(isNaN(that.value.nowTime)) {
        that.$set(that.value,"nowTime",that.value.limitTime);
      }
      if(that.value.nowTime > 0) {
        this.authTimeTimer = setInterval(function(){
            if(that.downState) {
              that.value.nowTime -= 1;
            }
//            console.log("that.value====================",that.value.nowTime);
            if (that.value.nowTime < 0) {
              clearTimeout(that.authTimeTimer);
              that.$emit("timeEnd");
            } 
        }, 1000);
      }
    },
    /**
      * 定时器暂停执行
      */
    suspend(){
      if (this.authTimeTimer) {
          clearInterval(this.authTimeTimer);
      }
    }
  }
}
        
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
